var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "right-side-menu" },
    [
      _c("div", { staticClass: "menu-title" }, [_vm._v("\n    装修选项\n  ")]),
      _vm._v(" "),
      _c(
        "el-menu",
        {
          staticClass: "menu-list",
          attrs: { "default-active": _vm.defaultActive },
          on: { select: _vm.onMenuSelect },
        },
        _vm._l(_vm.currentMenuItems, function (item) {
          return _c(
            "el-menu-item",
            { key: item.key, attrs: { index: item.key } },
            [_vm._v("\n      " + _vm._s(item.label) + "\n    ")]
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }